import Link from 'next/link'
import {
  GooglePlayStoreWhiteSvg,
  GooglePlayStoreBlackSvg,
  AppStoreWhiteSvg,
  AppStoreBlackSvg,
} from '@ui/components/Svg'
import { withDesktopStoreFallback } from '@ui/constants'

type Variant = 'dark' | 'black' | 'light' | 'white'

type Props = {
  downloadLink: string
  className?: string
  variant?: Variant
}

export const ButtonAppStore = ({
  downloadLink,
  className,
  variant = 'dark',
}: Props) => {
  return (
    <div className={className}>
      <Link
        href={withDesktopStoreFallback({
          link: downloadLink,
          store: 'appStore',
        })}
        className="h-full w-full"
      >
        {variant === 'dark' || variant === 'black' ? (
          <AppStoreBlackSvg className="h-full w-full" />
        ) : (
          <AppStoreWhiteSvg className="h-full w-full" />
        )}
      </Link>
    </div>
  )
}

export const ButtonGooglePlay = ({
  downloadLink,
  className,
  variant = 'dark',
}: Props) => {
  return (
    <div className={className}>
      <Link
        href={withDesktopStoreFallback({
          link: downloadLink,
          store: 'googlePlay',
        })}
        className="h-full w-full"
      >
        {variant === 'dark' || variant === 'black' ? (
          <GooglePlayStoreBlackSvg className="h-full w-full" />
        ) : (
          <GooglePlayStoreWhiteSvg className="h-full w-full" />
        )}
      </Link>
    </div>
  )
}
